//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            item: {},
            balance: 0,
            loading: true,
            firstLoading: true,
            transactions: [],
            payments: [],
            selectedRow: false,
            filterKey: ''
        };
    },
    created: function created() {
        var _this = this;

        Event.$on('view-past-resident-details', this.viewPastResidentDetails);
        Event.$on('refresh-past-resident-ledger', function () {
            _this.ledgerRefresh();
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('view-past-resident-details');
        Event.$off('refresh-past-resident-ledger');
    },

    methods: {
        viewPastResidentDetails: function viewPastResidentDetails(item) {
            var $el = this;
            $el.$children[0].$data.showModal = true;
            $el.item = item;
            $el.firstLoading = false;
            $el.item.lease_expiration_date = '';
            if (item.unit.unit_lease) {
                $el.item.lease_expiration_date = item.unit.unit_lease.lease_expiration_date;
            }
            $el.item.move_in_date = item.move_in_date;
            $el.item.rent_amount = item.unit.rent_amount;
            $el.item.phone = item.person.phone;
            $el.item.email = item.person.email;
            $el.item.full_name = item.person.full_name;
            $el.item.unit_name = item.unit.name;
            $el.ledgerRefresh();
        },
        statement: function statement() {
            var $el = this;
            Event.$emit('move-out-ledger', $el.item);
        },
        addNew: function addNew() {
            Event.$emit('show-gl-wizard', this.item);
        },
        addDeposit: function addDeposit() {
            Event.$emit('past-resident-ar-deposit', this.item);
        },
        editTransaction: function editTransaction(transaction) {
            Event.$emit('edit-gl-wizard', transaction);
        },
        modifyPayment: function modifyPayment(payment) {
            Event.$emit('edit-ledger-payment', payment);
        },
        ledgerRefresh: function ledgerRefresh() {
            var _this2 = this;

            var $el = this;
            $el.loading = true;
            axios.post('/prototype/resident/ledger/balance', { id: $el.item.id }).then(function (response) {
                _this2.balance = response.data;
            });
            axios.post('/prototype/resident/ledger', { id: $el.item.id }).then(function (response) {
                if (response.data) {
                    $el.transactions = response.data.transactions;
                    $el.transactions.map(function (trans) {
                        return trans['type'] = 'transaction';
                    });
                    $el.payments = response.data.payments;
                    $el.payments.map(function (payment) {
                        return payment['type'] = 'payment';
                    });
                    $el.nsfs = response.data.nsfs;
                    $el.nsfs.map(function (nsf) {
                        return nsf['type'] = 'nsf';
                    });
                }
                $el.loading = false;
            });
        }
    },

    computed: {
        filteredData: function filteredData() {

            var filterKey = this.filterKey && this.filterKey.toLowerCase();
            var data = this.transactions.concat(this.payments);

            data.sort(function (a, b) {
                if (new Date(a.created_at).getTime() > new Date(b.created_at).getTime()) return 1;
                if (new Date(a.created_at).getTime() < new Date(b.created_at).getTime()) return -1;
                return 0;
            });

            data.map(function (item, idx) {
                if (item.type == 'transaction') {
                    var amount = 0;

                    if (item['has_override']) {
                        amount = Number(item['override_amount']);
                    } else {
                        amount = Number(item['true_amount']);
                    }

                    if (item.is_debit) {

                        if (idx === 0) {
                            item['lineBalance'] = amount;
                        } else {
                            item['lineBalance'] = Number(data[idx - 1]['lineBalance']) + Number(amount);
                        }
                    } else {

                        if (idx === 0) {
                            item['lineBalance'] = -amount;
                        } else {
                            item['lineBalance'] = Number(data[idx - 1]['lineBalance']) - Number(amount);
                        }
                    }
                }
                if (item.type === "payment") {
                    // Reversed payments should not be tallied in running balance
                    if (item.reversal === null) {
                        if (idx === 0) {
                            item["lineBalance"] = -Number(item.amount);
                        } else {
                            item["lineBalance"] = (Number(data[idx - 1]["lineBalance"]) - Number(item.amount)).toFixed(2);
                            return item["lineBalance"]; //what does this do?
                        }
                    } else {
                        if (idx === 0) {
                            item["lineBalance"] = 0;
                        } else {
                            item["lineBalance"] = Number(data[idx - 1]["lineBalance"]);
                        }
                    }
                }
                if (item.type == 'nsf') {

                    item['lineBalance'] = Number(data[idx - 1]['lineBalance']);
                }
            });

            data.sort(function (a, b) {
                if (a.created_at != b.created_at) {
                    if (new Date(a.created_at).getTime() > new Date(b.created_at).getTime()) return -1;
                    if (new Date(a.created_at).getTime() < new Date(b.created_at).getTime()) return 1;
                    return 0;
                }
                return b.id - a.id;
            });

            if (filterKey) {
                data = data.filter(function (row) {
                    return Object.keys(row).some(function (key) {
                        return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
                    });
                });
            }

            return data;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/past-residents/PastResidentDetails.vue
// module id = J06j
// module chunks = 0 1